import { useQuery } from '@tanstack/react-query';
import { storePulseAlertsService } from '@/lib/services/supabase/store-pulse-alerts';

/** Nav badge / dashboard chip count - same attention-severity x open-state predicate the alerts page's default list uses (plan D-I), so the two can never drift on first load. */
export function useStorePulseAlertCounts() {
  const { data, isLoading } = useQuery({
    queryKey: ['store-pulse-alerts', 'counts'],
    queryFn: () => storePulseAlertsService.counts(),
  });
  return { count: data?.count ?? 0, isLoading };
}
